import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import CaseStudyContactTitle from "../components/case-study-footer-title"
import Footer from "../components/footer"

import CaseStudyLandingSection from "../components/case-study-landing-section"
import CaseStudyFooterNavSection from "../components/case-study-footer-nav-section"
import Niradhi from "../components/niradhi/Niradhi"

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
    }
  }

  componentDidMount() {
    if (!this.state.isMobile) {
      if (window.innerWidth <= 575) {
        this.setState({ isMobile: true })
      }
    }
  }

  footerText = () => {
    return <CaseStudyContactTitle />
  }

  render() {
    return (
      <Layout hideNavigator>
        <SEO title="Niradhi - Designing brand Identity for Niradhi" pathname={"/niradhi"} />
        <div className="container-fluid home-page niradhi-case-study">
          <CaseStudyLandingSection
            title={"Designing brand Identity for Niradhi"}
            subtitle={"Branding, Brand strategy"}
          />
          <Niradhi />
          <CaseStudyFooterNavSection
            title={"DealStreetAsia"}
            subtitle={"Design, Development"}
            to={"/deal-street-asia"}
            className={"deal-street-asia-view-case-study"}
            isMobile={this.state.isMobile}
          />
          <Footer contactTitle={this.footerText()} />
        </div>
      </Layout>
    )
  }
}
